import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import { Friend } from '@/core/interfaces';
import { CoinImage } from '@/app/shared/components';

interface FriendListItemProps {
	friend: Friend;
}

export const FriendListItem: React.FC<FriendListItemProps> = ({
	friend,
}: FriendListItemProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex rounded-2xl items-center bg-customer-900/50 p-2 option-menu-setting">
			<div className="flex flex-1 gap-2 items-center">
				<img
					className="max-w-[60px]"
					src={friend.level.image}
					alt={friend.level.name}
				/>

				<div className="flex flex-col">
					<p className="text-sm font-bold">{friend.name}</p>
					<div className="flex text-shadow-xs text-xs gap-2 items-center">
						{friend.level.name}
						<div className="flex items-center">
							<CoinImage classes="w-[16px]" />
							{numify(friend.pointsGenerated)}
						</div>
					</div>
				</div>
			</div>

			<div className="flex gap-1 items-center">
				<p className="text-sm">+{numify(friend.points)}</p>

				<CoinImage classes="drop-shadow-sm w-[20px]" />
			</div>
		</div>
	);
};
